export enum ButtonVariant {
  Plain = 'plain',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
}
